import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "inline-flex",
    backgroundColor: theme.colors.Zumthor,
    borderRadius: 12,
    padding: 4,
    border: `1px solid ${theme.colors.Periwinkle}`,
    "& button": {
      cursor: "pointer",
    }
  },
  segment: {
    position: "relative",
    border: "none",
    background: "transparent",
    padding: "10px 22px",
    minWidth: 140,
    cursor: "pointer",
    borderRadius: 9,
    color: theme.colors.Violet,
    fontFamily: theme.fontFamily.MARKPROMEDIUM,
    fontSize: 14,
    transition: "all 160ms ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    "&:hover:not(:disabled)": {
      color: theme.colors.DodgerBlue,
    },
    "&:focus": { outline: "none" },
    "&:focus-visible": {
      boxShadow: `0 0 0 2px ${theme.colors.DodgerBlue}33`,
    },
  },
  segmentActive: {
    backgroundColor: theme.colors.White,
    color: theme.colors.DodgerBlue,
    fontFamily: theme.fontFamily.MARKPROBOLD,
    boxShadow: "0 1px 3px rgba(62, 131, 251, 0.18)",
  },
  icon: {
    width: 16,
    height: 16,
    display: "inline-block",
  },
}));

export default function ViewSwitcher({ value, onChange, options }) {
  const classes = useStyles();
  return (
    <div className={classes.wrapper} role="tablist">
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${classes.segment} ${isActive ? classes.segmentActive : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.icon && (
              <img src={opt.icon} alt="" className={classes.icon} />
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
